import { useBoundStore } from '~/src/store';

const useBasketId = () => useBoundStore((store) => store.basketId);
const useSetBasketId = () => useBoundStore((store) => store.setBasketId);

export { useBasketId, useSetBasketId };
